module.exports = __webpack_public_path__ + "img/diamonds.fe67bb8b.png";